import { render, staticRenderFns } from "./ExpressDetail.vue?vue&type=template&id=851bf22c&scoped=true&"
import script from "./ExpressDetail.vue?vue&type=script&lang=js&"
export * from "./ExpressDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExpressDetail.vue?vue&type=style&index=0&id=851bf22c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851bf22c",
  null
  
)

export default component.exports